import axios from '@/libs/http'

/**
 * 钉钉登录
 */
export const dingTalkLogin = (code) => {
  return axios({
    url: '/s/dingtalk/login',
    params: {
      code
    },
    method: 'get'
  })
}

/**
 * 获取jsapi配置
 */
export const getJsApiConfig = (url) => {
  return axios({
    url: '/s/dingtalk/getJsApiConfig',
    params: {
      url
    },
    method: 'get'
  })
}



